import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class FormSaveQueueService {
  private readonly chains = new Map<string, Promise<unknown>>();

  enqueue<T>(key: string, executor: () => Promise<T>): Promise<T> {
    const previous = this.chains.get(key) ?? Promise.resolve();
    const next = previous.catch(() => {}).then(executor) as Promise<T>;

    this.chains.set(key, next);
    void next.finally(() => {
      if (this.chains.get(key) === next) {
        this.chains.delete(key);
      }
    });

    return next;
  }
}
